import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Popover } from '@/components/molecules/Popover'

interface IOutOfVotesAlertProps {
  isOpen: boolean
  onDismiss: () => void
}

export const OutOfVotesAlert: FC<IOutOfVotesAlertProps> = ({
  isOpen,
  onDismiss,
}) => {
  const { t } = useTranslation('common')
  return (
    <Popover
      hasIcon={false}
      isOpen={isOpen}
      onDismiss={onDismiss}
      actionText={t('okay')}
    >
      {t('contest.outOfVotes.message')}
    </Popover>
  )
}
